// extracted by mini-css-extract-plugin
export default {"sliderColor":"#4e83aa"};